module.exports = __webpack_public_path__ + "img/tx.rate.monthly.31d2a432.png";